import fetch from 'lib/fetch'
import { CHECKOUT_ENDPOINT } from './constants'
import { RequestMethod } from './RequestMethod'

interface CheckoutPayload {
  cartItemIds?: string[]
  // DEPRECATED: `sourceOrderId` is only used for replacement parts pilot.
  // Recurring replacement parts orders should use `subscriptionId` going forward.
  sourceOrderId?: string
  subscriptionId?: string
  aobAcknowledged?: boolean
  includeFreeGift?: boolean
}

export default function checkout(
  payload: CheckoutPayload
): Promise<APIResponse.Checkout> {
  return fetch(CHECKOUT_ENDPOINT, {
    method: RequestMethod.POST,
    body: JSON.stringify(payload),
  })
}
